import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import axios from "axios";
import { useState } from "react";
import toast from "react-hot-toast";

function NewPaymentMethod({ open, triggerFetch, closeDialog }) {
  const theme = useTheme();
  const [name, setName] = useState("");
  const [type, setType] = useState("");
  const [allowDiscount, setAllowDiscount] = useState(true);
  const [showAmount, setShowAmount] = useState(true);

  const [errors, setErrors] = useState({});

  const typeOptions = ["مسبقة الدفع", "دفع فوري", "آجلة الدفع"];

  // const [availableViewTypes, setAvailableViewTypes] = useState([]);
  // const fetchData = useCallback(async () => {
  //   // setInitialLoading(true);
  //   try {
  //     const viewTypes = await axios.get(
  //       `${process.env.REACT_APP_API_URL}/viewtype/`,
  //       {
  //         withCredentials: true,
  //       }
  //     );
  //     // setInitialLoading(false);
  //     setAvailableViewTypes(viewTypes.data);
  //   } catch (error) {
  //     // setInitialLoading(false);

  //   }
  // }, []);

  // useEffect(() => {
  //   fetchData();
  // }, [fetchData]);

  const handleSubmit = async () => {
    // Reset errors
    const newErrors = {};

    // Validation checks
    if (!name.trim()) newErrors.name = "الإسم مطلوب.";
    if (!type.trim()) newErrors.type = "النوع مطلوب.";
    // If there are errors, set them and prevent submission
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const newMethod = {
      name: name,
      type: type,
      allowDiscount: allowDiscount,
      showAmount: showAmount,
    };
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/paymentmethod`,
        newMethod,
        {
          withCredentials: true,
        }
      );
      if (res) {
        closeDialog();
        triggerFetch();
        toast.success("تم إضافة طريقة الدفع بنجاح!");
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message ||
          "An error occurred while creating the method."
      );
    }
  };
  return (
    <Dialog
      open={open}
      PaperProps={{
        style: {
          borderRadius: "12px",
          minWidth: "300px",
        },
      }}
    >
      <Box sx={{ padding: "24px 24px 0" }}>
        <Typography variant="h5">إضافة طريقة دفع جديدة</Typography>
      </Box>
      <DialogContent>
        <FormControl fullWidth sx={{ padding: "12px 0" }}>
          <TextField
            fullWidth
            label="إسم طريقة الدفع"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
            error={!!errors.name}
            helperText={errors.name}
          />
        </FormControl>
        <Box sx={{ padding: "12px 0" }}>
          <FormControl
            fullWidth
            sx={{ flex: "1 1 45%", minWidth: "250px" }}
            error={!!errors.type}
          >
            <InputLabel id="view-type-label">النوع</InputLabel>
            <Select
              fullWidth
              labelId="view-type-label"
              label="النوع"
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              {typeOptions.map((type, index) => (
                <MenuItem key={index} value={type}>
                  {type}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{errors.type}</FormHelperText>
          </FormControl>
        </Box>
        <Box>
          <FormControl sx={{ width: "100%" }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                margin: "12px 0",
              }}
            >
              <Typography>تفعيل الخصومات</Typography>
              <Switch
                checked={allowDiscount}
                onChange={(e) => setAllowDiscount(e.target.checked)}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
                margin: "12px 0",
              }}
            >
              <Typography>ظهور المبلغ في تعبئة المشاهدات</Typography>
              <Switch
                checked={showAmount}
                onChange={(e) => setShowAmount(e.target.checked)}
              />
            </Box>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => closeDialog()}
          variant="text"
          color={theme.palette.neutral[900]}
        >
          إغلاق
        </Button>
        <Button onClick={handleSubmit} variant="contained">
          إضافة
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default NewPaymentMethod;
